module.exports = __webpack_public_path__ + "img/duanzu.823ccd4f.png";